module.exports = __webpack_public_path__ + "static/img/brees-2006-top-image.742bc5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2006-top-image.jpg
// module id = x62v
// module chunks = 1